module Environments {
    module.directive("connectionstringValidator", [
        "EnvironmentsService", function (environmentsService) {
            return {
                require: "ngModel",
                link: function (scope, element, attrs, ngModel) {
                    element.on("blur", function () {
                        scope.waitingForConnectionStringValidation = true;
                        environmentsService.validateConnectionString(ngModel.$viewValue).then(function (validity) {
                            ngModel.$setValidity("validConnectionString", validity);
                            scope.waitingForConnectionStringValidation = false;
                        });
                    });
                    element.on("input", function () {
                        scope.$apply(function () {
                            ngModel.$setValidity("validConnectionString", true);
                        });
                    });
                }
            };
        }
    ]);
}